import * as React from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import { consts } from "../../common/consts";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
const drawerWidth = 227;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      height: "100%",
    },
    appBar: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
      backgroundColor: "#00152E",
      position: "relative",
      zIndex: 950,
    },
    list: {
      paddingTop: "40px",
      height: "100%",
    },
    listItem: {
      paddingLeft: 20,
      paddingRight: 0,
      "&:active": {
        borderLeft: "3px solid",
        borderColor: "#F4B827",
      },
      selected: {
        borderLeft: "3px solid",
        borderColor: "#fff",
      },
    },
    listActive: {
      borderLeft: "3px solid",
      borderColor: "#F4B827",
    },
    listItemText: {
      color: "#fff !important",
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
    },
  })
);

const SecondaryMenu = ({ selectedmenu }: any) => {
  const { authStore } = useSelector((state: RootState) => state);
  const classes = useStyles();
  const history = useHistory();

  const itemsList = [
    {
      text: "Users",
      to: "/settings/users",
      onClick: () => {
        history.push("/settings/users");
      },
      permissions: [
        consts.Permissions.SMAAdminManageUsers,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "User Profiles",
      to: "/settings/profiles",
      onClick: () => {
        history.push("/settings/profiles");
      },
      permissions: [
        consts.Permissions.SMAAdminManageUserprofiles,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Customers",
      onClick: () => history.push("/settings/customers"),
      permissions: [
        consts.Permissions.SMAAdminManageCustomers,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Locations",
      onClick: () => history.push("/settings/locations"),
      permissions: [
        consts.Permissions.SMAAdminManageLocations,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Wards",
      to: "/Wards",
      onClick: () => history.push("/settings/wards"),
      permissions: [
        consts.Permissions.SMAAdminManageWards,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Reasons For Delay",
      onClick: () => history.push("/settings/delayReasons"),
      permissions: [
        consts.Permissions.SMAAdminManageReasonsForDelay,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Reasons For Cancel",
      onClick: () => history.push("/settings/cancellationReasons"),
      permissions: [
        consts.Permissions.SMAAdminManageReasonsForDelay,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Reasons For Callout",
      onClick: () => history.push("/settings/calloutReasons"),
      permissions: [
        consts.Permissions.SMAAdminManageReasonsForDelay,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Global Settings",
      onClick: () => history.push("/settings/globalsettings"),
      permissions: [consts.Permissions.SMASuperUser],
    },
    {
      text: "Clusters",
      onClick: () => history.push("/settings/clusters"),
      permissions: [
        consts.Permissions.SMAAdminManageLocations,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Vehicles",
      onClick: () => history.push("/settings/vehicles"),
      permissions: [
        consts.Permissions.SMAAdminManageVehicles,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Reasons For Wait Time",
      onClick: () => history.push("/settings/waitTimeReasons"),
      permissions: [
        consts.Permissions.SMAAdminManageReasonsForDelay,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Billing",
      onClick: () => history.push("/settings/billing"),
      permissions: [
        consts.Permissions.SMAAdminManageCustomers,
        consts.Permissions.SMASuperUser,
      ],
    },
    {
      text: "Reasons For Reschedule",
      onClick: () => history.push("/settings/rescheduleReasons"),
      permissions: [
        consts.Permissions.SMAAdminManageCustomers,
        consts.Permissions.SMASuperUser,
      ],
    },
  ];

  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      open={true}
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
    >
      <List className={classes.list}>
        {itemsList.map((item, index) => {
          const { text, onClick } = item;
          return authStore?.data?.role
            ?.split(",")
            ?.some((p) => item.permissions.includes(p)) ? (
            <ListItem
              key={text}
              className={`${classes.listItem} ${
                text === selectedmenu ? classes.listActive : ""
              }`}
              button
              onClick={onClick}
            >
              <ListItemText className={classes.listItemText} primary={text} />
            </ListItem>
          ) : null;
        })}
      </List>
    </Drawer>
  );
};

export default withRouter(SecondaryMenu);
